import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Check, Clock, Sparkles, Mail, Zap, Layout, Palette, Link2 } from 'lucide-react';

const FounderWaiting = ({ accessStartsAt, plan, userName }) => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  
  // Target date: July 31, 2026 at 09:00 Madrid time
  const targetDate = new Date('2026-07-31T09:00:00+02:00');
  
  useEffect(() => {
    const updateCountdown = () => {
      const now = new Date();
      const diff = targetDate - now;
      
      if (diff <= 0) {
        // Access time reached - reload to get access
        window.location.reload();
        return;
      }
      
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      
      setCountdown({ days, hours, minutes, seconds });
    };
    
    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    
    return () => clearInterval(interval);
  }, []);
  
  const features = [
    { icon: Zap, text: 'Funnels completos generados con IA' },
    { icon: Layout, text: 'Landings listas para publicar' },
    { icon: Mail, text: 'Secuencias de email y copies de anuncios' },
    { icon: Palette, text: 'Creativos en todos los formatos' },
    { icon: Link2, text: 'Integraciones con Meta, Google, GoHighLevel, WordPress y más' },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-app-bg to-surface flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-500/10 rounded-full mb-6">
            <Sparkles className="w-4 h-4 text-brand-500" />
            <span className="text-brand-500 font-medium">Eres Founder</span>
          </div>
          
          <h1 className="text-3xl md:text-4xl font-bold text-text-main mb-4">
            Tu acceso Founder se desbloquea el <span className="text-brand-500">31 de julio</span>
          </h1>
          
          <p className="text-text-secondary text-lg">
            Estás dentro. Estamos puliendo los últimos detalles para que tu plataforma esté perfecta el día del lanzamiento.
          </p>
        </div>
        
        {/* Countdown */}
        <div 
          className="bg-surface border border-border-subtle rounded-2xl p-8 mb-8"
          style={{ boxShadow: '0 4px 24px rgba(108, 99, 255, 0.1)' }}
        >
          <div className="grid grid-cols-4 gap-4 text-center">
            <div className="bg-app-bg rounded-xl p-4">
              <div className="text-4xl md:text-5xl font-bold text-brand-500 tabular-nums">
                {String(countdown.days).padStart(2, '0')}
              </div>
              <div className="text-text-muted text-sm mt-1">días</div>
            </div>
            <div className="bg-app-bg rounded-xl p-4">
              <div className="text-4xl md:text-5xl font-bold text-brand-500 tabular-nums">
                {String(countdown.hours).padStart(2, '0')}
              </div>
              <div className="text-text-muted text-sm mt-1">horas</div>
            </div>
            <div className="bg-app-bg rounded-xl p-4">
              <div className="text-4xl md:text-5xl font-bold text-brand-500 tabular-nums">
                {String(countdown.minutes).padStart(2, '0')}
              </div>
              <div className="text-text-muted text-sm mt-1">min</div>
            </div>
            <div className="bg-app-bg rounded-xl p-4">
              <div className="text-4xl md:text-5xl font-bold text-brand-500 tabular-nums">
                {String(countdown.seconds).padStart(2, '0')}
              </div>
              <div className="text-text-muted text-sm mt-1">seg</div>
            </div>
          </div>
        </div>
        
        {/* Features Preview */}
        <div className="bg-surface border border-border-subtle rounded-2xl p-6 mb-8">
          <h3 className="font-semibold text-text-main mb-4 flex items-center gap-2">
            <Clock className="w-5 h-5 text-brand-500" />
            Esto es lo que te espera el día 9:
          </h3>
          <div className="space-y-3">
            {features.map((feature, idx) => (
              <div key={idx} className="flex items-center gap-3 text-text-secondary">
                <feature.icon className="w-5 h-5 text-brand-400 flex-shrink-0" />
                <span>{feature.text}</span>
              </div>
            ))}
          </div>
        </div>
        
        {/* Community CTA */}
        {/* Billing Note */}
        <div className="flex items-center gap-3 p-4 bg-emerald-500/10 border border-emerald-500/20 rounded-xl">
          <Check className="w-5 h-5 text-emerald-500 flex-shrink-0" />
          <p className="text-sm text-text-secondary">
            <strong className="text-text-main">No se te ha cobrado todavía.</strong> Tu primer cargo será el 31 de julio, el mismo día que se activa tu acceso.
          </p>
        </div>
        
        {/* Plan Info */}
        {plan && (
          <div className="mt-6 text-center text-sm text-text-muted">
            Tu plan: <span className="text-text-main font-medium capitalize">{plan}</span> — Precio Founder
          </div>
        )}
      </div>
    </div>
  );
};

export default FounderWaiting;
